<template>
  <div id="mapContainer"/>
</template>

<script>
import L from "leaflet";

export default {
  name: "SiteSelectionMapComponent",
  props: {
    sites: {type: Array, required: true}
  },
  emits: ['siteSelection'],
  data() {
    return {
      map: null,
      markers: [],
      clusters: {}
    };
  },
  watch: {
    sites: {
      handler() {
        if (!this.map) return;
        this.markers.forEach(marker => {
          this.map.removeLayer(marker);
        });
        this.markers = [];
        this.clusters = {};

        this.sites.forEach((site) => {
          const coordinates = [site.address.latitude, site.address.longitude];
          const content = `<div class="mb-1">
            <b>${site.name}</b><br>
            <span>${site.address.name}, ${site.address.postcode} ${site.address.city}</span>
          `;

          const popup = L.popup({content});
          const marker = L.marker(coordinates, {id: site.id, alt: site.name})
            .bindPopup(popup)
            .addTo(this.map);

          if (!this.clusters[site.cluster]) {
            this.clusters[site.cluster] = L.featureGroup().addTo(this.map);
          }
          this.clusters[site.cluster].addLayer(marker);

          marker.on("click", this.onMarkerClick);
          this.markers.push(marker);
        });
      },
      immediate: false
    }
  },
  mounted() {
    this.map = L.map('mapContainer').setView([46.4850, 2.5120], 5);

    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      detectRetina: true,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(this.map);
  },
  beforeUnmount() {
    this.map = null;
  },
  methods: {
    onMarkerClick(event) {
      const site = this.sites.find(s => s.id === event.target.options.id);
      this.$emit('siteSelection', site);
    },
    zoomOnSite(siteId) {
      this.markers.forEach(m => m.closePopup());
      const marker = this.markers.find(m => m.options.id === siteId);
      if (marker) {
        marker.openPopup();
        this.map.flyTo(marker.getLatLng(), 13, {duration: 0.75});
      }
    },
    zoomOnCluster(cluster) {
      this.markers.forEach(m => m.closePopup());
      const group = this.clusters[cluster];
      if (group) {
        this.map.fitBounds(group.getBounds(), {
          padding: [50, 50]
        });
      }
    }
  }
};
</script>

<style scoped lang="scss">
#mapContainer {
  height: 50vh;

  ::v-deep(.leaflet-tile) {
    mix-blend-mode: normal !important;
  }
}

</style>
